// FooterController
app.controller('FooterController', ['$scope', 'config',
    function($scope, config) {
        // Init 
        $scope.init = async function() {
            $scope.copyrightDate = new Date().getFullYear();
            if ($scope.distributorUsername) {
                $scope.hideEntityDetails = config.ADVISERSMETADATA[$scope.distributorUsername]['hideEntityDetails'] ? config.ADVISERSMETADATA[$scope.distributorUsername]['hideEntityDetails'] : false;
                $scope.footerCssClass = config.ADVISERSMETADATA[$scope.distributorUsername]['footerCssChanges'] ? config.ADVISERSMETADATA[$scope.distributorUsername]['footerCssChanges'] : '';
            }
        }

    }
]);